'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _section = require('../section');

var _section2 = _interopRequireDefault(_section);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputSearchResult = function InputSearchResult(_ref) {
  var children = _ref.children,
      isActive = _ref.isActive,
      spacing = _ref.spacing,
      styles = _ref.styles;
  return _react2.default.createElement(
    _section2.default,
    {
      background: isActive ? 'shade' : 'light',
      spacing: spacing,
      styles: styles.root
    },
    children
  );
};

InputSearchResult.propTypes = {
  /**
   * The contents of the search result
   */
  children: _propTypes2.default.any.isRequired,

  /**
   * Whether the item is the actively selected result
   */
  isActive: _propTypes2.default.bool,

  /**
   * The spacing to be applied to the result
   */
  spacing: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object]),

  /**
   * Custom styles to be applied
   */
  styles: _propTypes2.default.object
};

InputSearchResult.defaultProps = {
  spacing: { x: 1, y: 0.5 }
};

exports.default = (0, _withStyles2.default)(_styles2.default)(InputSearchResult);


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/input-search-result/index.js
// module id = 267
// module chunks = 0